"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AuthState = _interopRequireDefault(require("../AuthState"));

var _callEach = _interopRequireDefault(require("../utilities/callEach"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var namespace = "tr.auth.FakeLoginService.";

var getItem = function getItem(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage.getItem("".concat(namespace).concat(key)) || defaultValue;
  }
};

var setItem = function setItem(key, value) {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.setItem("".concat(namespace).concat(key), value);
  }
};

var removeItem = function removeItem(key) {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.removeItem("".concat(namespace).concat(key));
  }
};
/**
 * A fake auth service, which maintains an auth state for a user named John
 * Smith.
 */


var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);

    this.active = false;
    this.onChangeCallbacks = [];
    this.addItemToCart = this.addItemToCart.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.removeItemFromCart = this.removeItemFromCart.bind(this);

    if (typeof window !== "undefined") {
      if (!window.localStorage) {
        // Since this is a fake login service, we don't need to be thorough in
        // supporting non-localStorage scenarios.
        // eslint-disable-next-line no-console
        console.warn("localStorage is unavailable. Login may not function as expected.");
      }
    }
  }

  _createClass(_default, [{
    key: "activate",
    value: function activate() {
      if (!this.active) {
        this.active = true;
        this.privateTriggerChange();
      }
    }
  }, {
    key: "addItemToCart",
    value: function addItemToCart() {
      setItem("itemsInCart", this.itemsInCart + 1);
      this.privateTriggerChange();
    }
  }, {
    key: "removeItemFromCart",
    value: function removeItemFromCart() {
      if (this.itemsInCart > 0) {
        setItem("itemsInCart", this.itemsInCart - 1);
        this.privateTriggerChange();
      }
    }
  }, {
    key: "login",
    value: function login() {
      setItem("authState", _AuthState["default"].LOGGED_IN);
      setItem("itemsInCart", 2); // eslint-disable-line no-magic-numbers

      setItem("userName", "John Smith");
      setItem("userFirstName", "John");
      this.privateTriggerChange();
    }
  }, {
    key: "logout",
    value: function logout() {
      if (typeof window !== "undefined" && window.localStorage) {
        removeItem("authState");
        removeItem("itemsInCart");
        removeItem("userName");
        removeItem("userFirstName");
        this.privateTriggerChange();
      }
    }
  }, {
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);
        return true;
      }

      return false;
    }
  }, {
    key: "privateTriggerChange",
    value: function privateTriggerChange() {
      (0, _callEach["default"])(this.onChangeCallbacks, this);
    }
  }, {
    key: "authState",
    get: function get() {
      if (this.active) {
        return parseInt(getItem("authState", _AuthState["default"].LOGGED_OUT));
      }

      return _AuthState["default"].UNKNOWN;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      if (this.active) {
        return parseInt(getItem("itemsInCart", 0));
      }

      return 0;
    }
  }, {
    key: "userName",
    get: function get() {
      if (this.active) {
        return getItem("userName");
      }

      return null;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      if (this.active) {
        return getItem("userFirstName");
      }

      return null;
    }
  }]);

  return _default;
}();

exports["default"] = _default;